import { NgModule } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import {
    Activity,
    ArrowDownCircle,
    ArrowRight,
    ChevronLeft,
    ChevronRight,
    Clock,
    Edit,
    File,
    Maximize,
    MessageSquare,
    Minimize,
    Play,
    Plus,
    Trash,
    User,
    Users,
    Zap,
    X,
    Check,
    ChevronDown,
    ChevronUp,
    ArrowLeft,
    LogOut,
    LogIn,
    Mail,
    Lock,
    ExternalLink,
    Award,
    Package,
    BarChart2,
    TrendingUp,
    Sliders,
    Target,
    Eye,
    PlusCircle,
    Clipboard,
    FileText,
    HelpCircle,
    Shield,
    Info,
    Truck,
    XCircle,
    RefreshCw,
    MinusCircle,
    MoreHorizontal,
    PlusSquare,
    Slash,
    Sun,
    Gift,
    Copy,
    EyeOff,
    Volume2,
    VolumeX,
    ThumbsUp,
    ThumbsDown,
    Edit2,
    MessageCircle,
    Share2,
    Move,
} from 'angular-feather/icons';

const icons = {
    Zap,
    User,
    Users,
    Activity,
    Clock,
    Play,
    Plus,
    Trash,
    ArrowDownCircle,
    File,
    MessageSquare,
    ArrowRight,
    Edit,
    Minimize,
    Maximize,
    ChevronLeft,
    ChevronRight,
    X,
    Check,
    ChevronDown,
    ChevronUp,
    ArrowLeft,
    LogOut,
    LogIn,
    Mail,
    Lock,
    Award,
    Package,
    ExternalLink,
    BarChart2,
    TrendingUp,
    Sliders,
    Target,
    Eye,
    Shield,
    Info,
    Truck,
    XCircle,
    PlusCircle,
    Clipboard,
    FileText,
    RefreshCw,
    HelpCircle,
    MinusCircle,
    MoreHorizontal,
    PlusSquare,
    Slash,
    Sun,
    Gift,
    Copy,
    EyeOff,
    Volume2,
    VolumeX,
    ThumbsUp,
    ThumbsDown,
    Edit2,
    MessageCircle,
    Share2,
    Move,
};

@NgModule({
    imports: [FeatherModule.pick(icons)],
    exports: [FeatherModule],
})
export class IconsModule {}
